<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import Auth from '@/layouts/auth';
import Default from '@/layouts/default';
import Dashboard from '@/layouts/dashboard';
import Exam from '@/layouts/exam';

export default {
  components: {
    Auth,
    Default,
    Dashboard,
    Exam
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'default';
    }
  },
  created() {
    const authInterceptor = config => {
      config.headers.Authorization = `Bearer ${this.$store.getters.token}`;
      return config;
    };

    this.$http.interceptors.request.use(authInterceptor);
    this.$http.interceptors.response.use(undefined, err => {
      return new Promise(() => {
        if (
          err.response.status === 401 &&
          err.config &&
          !err.config.__isRetryRequest
        ) {
          this.$store.dispatch('logout').then(() => {
            this.$router.push('/login');
          });
        }
        throw err;
      });
    });
  },
  async mounted() {
    await this.$store.dispatch('siteParams');
  }
};
</script>
<style lang="scss">
@import '@/assets/styles/app.scss';
</style>
